import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle, ShieldCheck } from "lucide-react";
import { BRAND } from "../../data/menu";

export default function Footer() {
  return (
    <footer className="relative bg-[#2b1414] text-[#f7f0e0] pt-20 pb-10 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        {/* Big wordmark */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="border-b border-[#f7f0e0]/15 pb-12"
        >
          <div className="flex items-center gap-4 mb-6">
            <img src={BRAND.logo} alt="Puneri Kitchen" className="h-14 w-14 rounded-full object-cover ring-1 ring-[#f7f0e0]/20" />
            <p className="text-sm uppercase tracking-[0.28em] text-[#d97706]">{BRAND.tagline}</p>
          </div>
          <h2 className="font-display font-bold tracking-tighter leading-none text-6xl sm:text-8xl md:text-[10rem]">
            PUNERI <span className="italic font-accent text-[#d97706]">Kitchen</span>
          </h2>
          <p className="mt-4 font-display text-2xl text-[#f7f0e0]/70">{BRAND.marathi}</p>
        </motion.div>

        {/* Details */}
        <div className="grid md:grid-cols-4 gap-10 py-12">
          <div className="space-y-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#d97706]">Visit / Order</p>
            <a href={`https://wa.me/${BRAND.phoneRaw}`} target="_blank" rel="noreferrer" data-testid="footer-phone" className="flex items-start gap-3 hover:text-[#d97706] transition-colors">
              <Phone size={18} className="mt-0.5 shrink-0" />
              <span>{BRAND.phone}<span className="block text-xs text-[#f7f0e0]/60">Call &amp; WhatsApp</span></span>
            </a>
            <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="flex items-start gap-3 hover:text-[#d97706] transition-colors">
              <Mail size={18} className="mt-0.5 shrink-0" /> {BRAND.email}
            </a>
            <a href={`mailto:${BRAND.emailSupport}`} data-testid="footer-email-support" className="flex items-start gap-3 hover:text-[#d97706] transition-colors">
              <Mail size={18} className="mt-0.5 shrink-0" />
              <span>{BRAND.emailSupport}<span className="block text-xs text-[#f7f0e0]/60">Support &amp; suggestions</span></span>
            </a>
          </div>
          <div className="md:col-span-2 space-y-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#d97706]">Registered Address</p>
            <p className="flex items-start gap-3 text-[#f7f0e0]/85 leading-relaxed max-w-sm">
              <MapPin size={18} className="mt-0.5 shrink-0" /> {BRAND.address}
            </p>
            <p className="flex items-start gap-3 text-[#f7f0e0]/70 text-sm">
              <ShieldCheck size={18} className="mt-0.5 shrink-0 text-[#1e5128]" />
              FSSAI Lic. No. {BRAND.fssai}
            </p>
          </div>
          <div className="space-y-4">
            <p className="text-xs uppercase tracking-[0.25em] text-[#d97706]">Follow Us</p>
            <div className="flex gap-3">
              {[
                { Icon: Instagram, href: `https://instagram.com/${BRAND.instagram}`, tid: "footer-instagram" },
                { Icon: Facebook, href: BRAND.facebookUrl, tid: "footer-facebook" },
                { Icon: MessageCircle, href: `https://wa.me/${BRAND.phoneRaw}`, tid: "footer-whatsapp" },
              ].map(({ Icon, href, tid }) => (
                <a
                  key={tid}
                  data-testid={tid}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="grid h-11 w-11 place-items-center rounded-full ring-1 ring-[#f7f0e0]/25 transition-colors duration-300 hover:bg-[#d97706] hover:ring-[#d97706]"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
            <p className="text-sm text-[#f7f0e0]/70">Instagram @{BRAND.instagram} · Facebook {BRAND.facebook}</p>
            <a
              data-testid="footer-order-now"
              href={`https://wa.me/${BRAND.phoneRaw}`}
              target="_blank"
              rel="noreferrer"
              className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#d97706] px-6 py-3 text-sm font-semibold text-[#2b1414] transition-colors duration-300 hover:bg-[#f7f0e0]"
            >
              Order Now
            </a>
          </div>
        </div>

        <div className="border-t border-[#f7f0e0]/15 pt-8 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-[#f7f0e0]/60">
          <p>© {new Date().getFullYear()} Puneri Kitchen. Prepared with love in Bangalore.</p>
          <p>Free home delivery* · Min. order applies · Packing charges extra</p>
        </div>
      </div>
    </footer>
  );
}
